export default __webpack_public_path__ + "static/media/boringbed.a1e180cf.png";